import React, { useEffect, useMemo, useState, useCallback } from "react";
import Loader from "../components/Loader";
import { observer } from "mobx-react-lite";
import { ReportLicensing } from "../components/allreport/ReportLicensing";
import { Navigate } from "react-router-dom";
import { VersionReport } from "../components/allreport/version/VersionReport";
import RolesState from "../api/RolesState";
import ReportData from "../api/ReportData";
import { SerialisatonReport } from "../components/allreport/serialisation/SerialisatonReport";
import User from "../api/User";
import {
  findPendingTemplate,
  REPORT_TAB_SUBSCRIPTION,
  REPORT_TAB_VERSION,
  REPORT_TAB_SERIALISATION,
  REPORT_TEMPLATE_APPLY_EVENT,
} from "../utils/reportTemplatesStorage";

const TAB_SUBSCRIPTION = REPORT_TAB_SUBSCRIPTION;
const TAB_VERSION = REPORT_TAB_VERSION;
const TAB_SERIALISATION = REPORT_TAB_SERIALISATION;

const AllReport = observer(() => {
  const [activeTab, setActiveTab] = useState(null);

  const tabSubscriptionVisible =
    RolesState.subscription_rights || User.user?.is_superuser;
  const tabVersionVisible =
    RolesState.all_soft_client || User.user?.is_superuser;
  const tabSerialisationVisible =
    (RolesState.all_soft_client && RolesState.get_all_licensing) ||
    RolesState.subscription_rights ||
    User.user?.is_superuser;

  const resolveTabFromPending = useCallback(() => {
    const pending = findPendingTemplate();
    if (!pending) {
      return null;
    }
    if (pending.tab === TAB_SUBSCRIPTION && tabSubscriptionVisible) {
      return TAB_SUBSCRIPTION;
    }
    if (pending.tab === TAB_VERSION && tabVersionVisible) {
      return TAB_VERSION;
    }
    if (pending.tab === TAB_SERIALISATION && tabSerialisationVisible) {
      return TAB_SERIALISATION;
    }
    return null;
  }, [tabSerialisationVisible, tabSubscriptionVisible, tabVersionVisible]);

  const syncInitialTab = useCallback(() => {
    const fromPending = resolveTabFromPending();
    if (fromPending) {
      setActiveTab(fromPending);
      return;
    }

    const active_report = sessionStorage.getItem("active_report");
    if (active_report === TAB_SERIALISATION && tabSerialisationVisible) {
      setActiveTab(TAB_SERIALISATION);
    } else if (
      (RolesState.subscription_rights || User.user?.is_superuser) &&
      active_report !== TAB_SERIALISATION
    ) {
      setActiveTab(TAB_SUBSCRIPTION);
    } else if (
      RolesState.all_soft_client &&
      RolesState.get_all_licensing &&
      active_report !== TAB_SERIALISATION
    ) {
      setActiveTab(TAB_VERSION);
    } else if (active_report === TAB_SERIALISATION) {
      setActiveTab(TAB_SERIALISATION);
    } else if (tabSubscriptionVisible) {
      setActiveTab(TAB_SUBSCRIPTION);
    } else if (tabVersionVisible) {
      setActiveTab(TAB_VERSION);
    } else if (tabSerialisationVisible) {
      setActiveTab(TAB_SERIALISATION);
    }
  }, [
    resolveTabFromPending,
    tabSerialisationVisible,
    tabSubscriptionVisible,
    tabVersionVisible,
  ]);

  useEffect(() => {
    syncInitialTab();
  }, [syncInitialTab]);

  useEffect(() => {
    const handler = () => {
      const fromPending = resolveTabFromPending();
      if (fromPending) {
        setActiveTab(fromPending);
      }
    };
    window.addEventListener(REPORT_TEMPLATE_APPLY_EVENT, handler);
    return () =>
      window.removeEventListener(REPORT_TEMPLATE_APPLY_EVENT, handler);
  }, [resolveTabFromPending]);

  const tabClass = (tab) => `tab-item${activeTab === tab ? " active" : ""}`;

  const reportReady = useMemo(
    () =>
      (RolesState.all_soft_client && ReportData.soft_version) ||
      (RolesState.subscription_rights && ReportData.subscription) ||
      RolesState.subscription_rights,
    [],
  );

  if (activeTab === null) {
    return null;
  }

  if (!RolesState.all_soft_client && !RolesState.subscription_rights) {
    return <Navigate to="/noright" />;
  }

  return (
    <div className="main-page company-card-v4 reports-page-v4">
      <header className="card header-card reports-page-header">
        <div className="header-top">
          <div className="company-title">
            <div className="compamy-title-name-container">
              <span className="req-label">Аналитика</span>
              <h1>Отчёты</h1>
            </div>
          </div>
        </div>
      </header>

      <nav
        className="navigation-tabs reports-page-tabs"
        role="tablist"
        aria-label="Разделы отчётов"
      >
        {tabSubscriptionVisible ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_SUBSCRIPTION}
            className={tabClass(TAB_SUBSCRIPTION)}
            onClick={() => setActiveTab(TAB_SUBSCRIPTION)}
          >
            Подписки
          </button>
        ) : null}
        {tabVersionVisible ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_VERSION}
            className={tabClass(TAB_VERSION)}
            onClick={() => setActiveTab(TAB_VERSION)}
          >
            Версия софта
          </button>
        ) : null}
        {tabSerialisationVisible ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_SERIALISATION}
            className={tabClass(TAB_SERIALISATION)}
            onClick={() => setActiveTab(TAB_SERIALISATION)}
          >
            Сериализация
          </button>
        ) : null}
      </nav>

      <div className="reports-tab-panel">
        {!reportReady ? (
          <Loader />
        ) : (
          <>
            {activeTab === TAB_SUBSCRIPTION &&
            RolesState.subscription_rights ? (
              <ReportLicensing />
            ) : null}
            {activeTab === TAB_VERSION && RolesState.all_soft_client ? (
              <VersionReport />
            ) : null}
            {(activeTab === TAB_SERIALISATION && RolesState.all_soft_client) ||
            (RolesState.subscription_rights &&
              activeTab === TAB_SERIALISATION) ? (
              <SerialisatonReport />
            ) : null}
          </>
        )}
      </div>
    </div>
  );
});
export { AllReport };
